RivalIQ.apps.Insights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Posts = RivalIQ.data.CacheLayer.extend({
        name: 'InsightsPosts',

        cacheKeys: [
            'companyId',
            'channel',
            'filter',
            'sort',
            'sortOrder',
            'timePeriod',
            'page',
            'limit'
        ],

        loadData: function (attributes) {
            const companyId = attributes.companyId;
            const channel = attributes.channel;
            const timePeriod = attributes.timePeriod;
            const sort = attributes.sort;
            const sortOrder = attributes.sortOrder;
            const page = (attributes.page || 1);
            const pageSize = attributes.limit;
            const filter = attributes.filter;

            const collection = App.collections.Posts.create(companyId, channel,
                timePeriod, sort, sortOrder, page, pageSize, filter);

            return collection.fetch().then(_.constant(collection));
        },

        fetch: function (params) {
            const me = this;
            return me.getOrLoad(params);
        }
    });

    data.Posts = new Posts();

});
